import React, { useEffect, useState } from "react";
import NFLOptimizer from "./NflOptimizer";
import NFLLateSwap from "./NFLLateSwap";

const useStickyState = (key, init) => {
  const [v, setV] = useState(() => {
    try {
      const raw = localStorage.getItem(key);
      return raw != null ? JSON.parse(raw) : init;
    } catch {
      return init;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(v));
    } catch {}
  }, [key, v]);

  return [v, setV];
};

export default function NFLOptimizerPage() {
  const [tab, setTab] = useStickyState("nfl.activeTab", "optimizer");

  return tab === "optimizer" ? (
    <NFLOptimizer activeTab={tab} setActiveTab={setTab} />
  ) : (
    <NFLLateSwap activeTab={tab} setActiveTab={setTab} />
  );
}